import { IApiError } from '@frontend/request';

import { ISymbol } from '@aqx-core/common/api/market';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';
import { IFavouriteWatchlistParams, IGetWatchlistParams, watchlistAPI } from '@aqx-core/common/api/watchlist';

class WatchlistAPIController {
  private watchlistAC?: AbortController;

  public getWatchlistWithMiniChart = async (
    params: IGetWatchlistParams,
    callbacks: IAPIControllerCallbacks<ISymbol[]>
  ) => {
    try {
      const { result } = await watchlistAPI.getWatchlistWithMiniChart(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public favouriteSymbol = async (params: IFavouriteWatchlistParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await watchlistAPI.favouriteSymbol(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public unfavouriteSymbol = async (params: IFavouriteWatchlistParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await watchlistAPI.unfavouriteSymbol(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public getWatchlistWithoutMiniChart = async (
    params: IGetWatchlistParams,
    callbacks: IAPIControllerCallbacks<ISymbol[]>
  ) => {
    try {
      this.watchlistAC?.abort();
      this.watchlistAC = new AbortController();
      const { abortable = true, ...restParams } = params;

      const { result } = await watchlistAPI.getWatchlistWithoutMiniChart(
        restParams,
        abortable ? this.watchlistAC.signal : undefined
      );
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    } finally {
      if (!!callbacks.onFinally) {
        callbacks.onFinally();
      }
    }
  };
}

export const watchlistAPIController = new WatchlistAPIController();
